import WriteButton from "@/components/WriteButton";
import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/pos-api";
import { toast } from "sonner";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Pencil, Store as StoreIcon } from "lucide-react";

export default function Stores() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [name, setName] = useState("");

  const load = async () => {
    try { setItems((await api.get("/stores")).data); }
    catch (e) { toast.error(apiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!name.trim()) return toast.error("Nama toko wajib diisi");
    try {
      await api.put(`/stores/${editing.id}`, { name });
      toast.success("Toko disimpan");
      setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <>
      <PageHeader title="Profil Toko" subtitle="Satu tenant untuk satu toko" />
      <div className="flex-1 overflow-y-auto p-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="store-list">
          {items.map((s) => (
            <div key={s.id} data-testid={`store-card-${s.id}`} className="rounded-xl border p-4 border-ui-line bg-ui-soft">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="h-11 w-11 rounded-xl bg-brand-soft text-brand-readable flex items-center justify-center"><StoreIcon className="h-5 w-5" /></div>
                  <div>
                    <div className="font-semibold">{s.name}</div>
                  </div>
                </div>
                <div className="flex gap-1">
                  <WriteButton plain data-testid={`edit-store-${s.id}`} onClick={() => { setEditing(s); setName(s.name); setOpen(true); }} className="h-8 w-8 rounded-lg bg-ui-card hover:bg-ui-muted-surface flex items-center justify-center"><Pencil className="h-4 w-4 text-ui-muted" /></WriteButton>
                </div>
              </div>
            </div>
          ))}
          {!items.length && <p className="text-sm text-ui-muted">Pilih tenant untuk melihat profil toko.</p>}
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="store-form-dialog" className="bg-ui-card border-ui-line text-ui-text max-w-sm">
          <DialogHeader><DialogTitle className="font-heading">Edit Profil Toko</DialogTitle></DialogHeader>
          <div className="space-y-1.5">
            <Label className="text-xs text-ui-muted">Nama Toko</Label>
            <Input data-testid="store-name-input" value={name} onChange={(e) => setName(e.target.value)} className="bg-ui-card border-ui-line" placeholder="Nama toko" />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} className="border-ui-line bg-transparent hover:bg-ui-card">Batal</Button>
            <WriteButton data-testid="save-store-btn" onClick={save} className="bg-brand-button hover:bg-brand-button text-ui-text font-bold">Simpan</WriteButton>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
